module.exports = __webpack_public_path__ + "img/bg_illu_small.a930447a.png";